import { ResourcesInstanceConfig } from "../interfaces/resources-instance-config";
import { NotebookEnvironment } from "../interfaces/notebook-environment";
import { UserUsage } from "../interfaces/user-usage";

export const APP_CONFIG = (window as any)['APP_CONFIG'];

export const NOTEBOOK_DEFAULTS = APP_CONFIG.NOTEBOOK_DEFAULTS;

export const STANDARD_CPU_INSTANCES : ResourcesInstanceConfig[] = APP_CONFIG.STANDARD_CPU_INSTANCES;
export const DEFAULT_MAX_USER_USAGE : UserUsage = APP_CONFIG.DEFAULT_MAX_USER_USAGE;
export const INITIAL_CURRENT_USER_USAGE : UserUsage = APP_CONFIG.INITIAL_CURRENT_USER_USAGE;

export const STOP_QUOTA_MESSAGE = APP_CONFIG.STOP_QUOTA_MESSAGE;
export const START_QUOTA_MESSAGE = APP_CONFIG.START_QUOTA_MESSAGE;
export const DELETE_MESSAGE = APP_CONFIG.DELETE_MESSAGE;
export const SOMETHING_WENT_WRONG_MESSAGE=APP_CONFIG.SOMETHING_WENT_WRONG_MESSAGE;

export const NOTEBOOK_TARGET_STATUSES = APP_CONFIG.NOTEBOOK_TARGET_STATUSES;
export const NOTEBOOK_TRANSITIONAL_STATUSES = APP_CONFIG.NOTEBOOK_TRANSITIONAL_STATUSES;
export const DOCUMENTATION_HEADER_LINK=APP_CONFIG.DOCUMENTATION_HEADER_LINK;
export const ENV_VERSIONS_DOC_LINK=APP_CONFIG.ENV_VERSIONS_DOC_LINK;
export const TUTORIAL_SELECTION_HINT=APP_CONFIG.TUTORIAL_SELECTION_HINT;
export const ENV_VERSIONS_HINT=APP_CONFIG.ENV_VERSIONS_HINT;
export const ENV_VERSIONS_HINT_LINK_TEXT=APP_CONFIG.ENV_VERSIONS_HINT_LINK_TEXT;
export const ACCOUNT_SETTINGS_LINK=APP_CONFIG.ACCOUNT_SETTINGS_LINK;
export const PLATFORM_HOME_LINK=APP_CONFIG.PLATFORM_HOME_LINK;
export const SUPPORT_LINK=APP_CONFIG.SUPPORT_LINK;
export const CODE_OF_CONDUCT_LINK=APP_CONFIG.CODE_OF_CONDUCT_LINK;
export const TERMS_AND_CONDITIONS_LINK=APP_CONFIG.TERMS_AND_CONDITIONS_LINK;
export const PRIVACY_POLICIES_LINK=APP_CONFIG.PRIVACY_POLICIES_LINK;
export const LEGAL_NOTICE_LINK=APP_CONFIG.LEGAL_NOTICE_LINK;
export const DESTINATION_EARTH_LINK=APP_CONFIG.DESTINATION_EARTH_LINK;
export const EU_COMMISSION_LINK=APP_CONFIG.EU_COMMISSION_LINK;
export const ECMWF_LINK=APP_CONFIG.ECMWF_LINK;
export const ESA_LINK=APP_CONFIG.ESA_LINK;
export const EUMETSAT_LINK=APP_CONFIG.EUMETSAT_LINK;
export const NOTEBOOK_STATUS_LABELS: Record<string, string> =APP_CONFIG.NOTEBOOK_STATUS_LABELS;
export const GATEWAY_ERROR_MESSAGE=APP_CONFIG.GATEWAY_ERROR_MESSAGE;
export const USE_PROXY=APP_CONFIG.USE_PROXY;
export const NOTEBOOK_RUNNING_RELEVANT_STATUSES=APP_CONFIG.NOTEBOOK_RUNNING_RELEVANT_STATUSES;
export const NOTEBOOK_STOPPED_RELEVANT_STATUSES=APP_CONFIG.NOTEBOOK_STOPPED_RELEVANT_STATUSES;
export const NOTEBOOK_CPU_RELEVANT_STATUSES=APP_CONFIG.NOTEBOOK_CPU_RELEVANT_STATUSES;
export const NOTEBOOK_STORAGE_RELEVANT_STATUSES=APP_CONFIG.NOTEBOOK_STORAGE_RELEVANT_STATUSES;
export const DELETE_FAILED_NOTEBOOKS=APP_CONFIG.DELETE_FAILED_NOTEBOOKS;
export const UPDATE_STATUS_DELAY=APP_CONFIG.UPDATE_STATUS_DELAY;
export const SERVICE_SHORT_DESCRIPTION=APP_CONFIG.SERVICE_SHORT_DESCRIPTION;

export const SERVICE_FULL_DESCRIPTION_1=APP_CONFIG.SERVICE_FULL_DESCRIPTION_1;
export const SERVICE_FULL_DESCRIPTION_2=APP_CONFIG.SERVICE_FULL_DESCRIPTION_2;
export const SERVICE_FULL_DESCRIPTION_3=APP_CONFIG.SERVICE_FULL_DESCRIPTION_3;

export const QISKIT_TUTORIALS_FRAMEWORK_ID: string = APP_CONFIG.QISKIT_TUTORIALS_FRAMEWORK_ID;

export const QISKIT_TUTORIALS_FRAMEWORK_VERSION: string = APP_CONFIG.QISKIT_TUTORIALS_FRAMEWORK_VERSION;

export const QISKIT_TUTORIALS_VOLUME = APP_CONFIG.QISKIT_TUTORIALS_VOLUME as {
  mountPath: string;
  permission: 'RO' | 'RW' | 'RWD';
  volumeSource: {
    publicGit: {
      url: string;
    };
  };
};
